module.exports = __webpack_public_path__ + "static/media/ico-search-partner-darkblue.101258ec.svg";